export default {
  props: ["items"],
  data() {
    return {
      scrollTop: 0,
      wrapperHeight: 0,
      contentHeight: 0,
      speed: 0.2,
      // 每帧移动 px 数
      timer: null,
      paused: false
    };
  },
  computed: {
    scrollStyle() {
      return {
        transform: `translateY(-${this.scrollTop}px)`,
        transition: 'none'
      };
    }
  },
  methods: {
    startScroll() {
      this.timer = requestAnimationFrame(this.scrollStep);
    },
    scrollStep() {
      if (this.paused) return;
      this.scrollTop += this.speed;
      if (this.scrollTop >= this.contentHeight / 2) {
        this.scrollTop = 0;
      }
      this.timer = requestAnimationFrame(this.scrollStep);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.wrapperHeight = this.$refs.wrapper.offsetHeight;
      this.contentHeight = this.$refs.content.offsetHeight;
      this.startScroll();
    });
  },
  unmounted() {
    cancelAnimationFrame(this.timer);
  }
};